import React from "react";
import Select from "react-select/async";
import {Controller} from "react-hook-form";
import "../../assets/css/pages/multi-select-async.css";

export default function ({
                           control,
                           label,
                           placeholder,
                           name,
                           parentClasses,
                           errorMessage,
                           values = [],
                           optionLabel = "name",
                           optionValue = "id",
                           search,
                           disabled,
                           defaultOptions = false,
                           loadTrigger = "",
                         }) {

  return (
    <>
      <div className={` ${parentClasses}`}>
        <label className='form-label fs-6 fw-bolder text-dark'>
          {label}
        </label>
        <Controller
          name={name}
          control={control}
          render={({field: {value, onChange, onBlur}}) => {
            return (
              <div>
                <Select
                  key={loadTrigger}
                  isDisabled={disabled}
                  styles={{
                    option: (base) => ({
                      ...base,
                      color: `blue`,
                    }),
                  }}
                  placeholder={placeholder}
                  isMulti={true}
                  getOptionLabel={(option) => option[optionLabel]}
                  getOptionValue={(option) => option[optionValue]}
                  onChange={(options) =>
                    onChange(options?.map((option) => option?.[optionValue]))
                  }
                  onBlur={onBlur}
                  value={values.filter((option) => value?.includes(option?.[optionValue]))}
                  loadOptions={(val) => search(val)}
                  defaultOptions={defaultOptions}
                />
                {
                  errorMessage && (
                    <div className="fv-plugins-message-container invalid-feedback">
                      <div>{errorMessage}</div>
                    </div>
                  )
                }
              </div>
            );
          }}
        />
      </div>
    </>
  );
}